module.exports = __webpack_public_path__ + "img/user-robot.8b85efd0.svg";